
<!--
 * @Description: 修改密码
 * @Author: 王赵坤
 * @Date: 2022-10-21 14:58:12
 * @LastEditors: PF
-->
<template>
  <div>
    <el-dialog class="w400 h400" :model-value="openXiuGaiMiMa" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon"><Edit /></el-icon>
          <span class="header-title">修改密码</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openXiuGaiMiMa', emits, false)">
            <el-icon><Close /></el-icon>
          </el-button>
        </div>
      </template>
      <el-form ref="ruleFormRef" :model="ruleForm" label-width="80px" status-icon>
        <el-form-item label="原密码" prop="oldpwd" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
          <el-input v-model="ruleForm.oldpwd" :rows="2" type="password" show-password />
        </el-form-item>
        <el-form-item label="新密码" prop="newpwd" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
          <el-input v-model="ruleForm.newpwd" :rows="2" type="password" show-password />
        </el-form-item>
        <el-form-item label="确认密码" prop="newpwdr" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
          <el-input v-model="ruleForm.newpwdr" :rows="2" type="password" show-password />
        </el-form-item>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
          <el-button type="primary" @click="submitForm()">确认修改</el-button>
            <el-button type="info" @click="closeWindow('openXiuGaiMiMa', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script setup>
import { ref, defineProps, defineEmits, unref } from 'vue'
import { closeWindow } from '@/api/common.js'
import { mimaEdit } from '@/api/login'
import { warningPrompt, successPrompt } from '@/utils/promptInfo'

const props = defineProps({ openXiuGaiMiMa: { type: Boolean, required: true }, xiugaimimaObj: { type: Object, required: false } })
const emits = defineEmits(['update:openXiuGaiMiMa', 'ReturnData'])

const ruleFormRef = ref(null)
const ruleForm = ref({
  menuId: sessionStorage.getItem('menuId'), // 菜单ID
  oldpwd: '',
  newpwd: '',
  newpwdr: ''
})

// 关闭
const handleClose = () => {
  emits('update:openXiuGaiMiMa', false)
  const form = unref(ruleFormRef)
  if (!form) return
  form.resetFields()
  ruleForm.value = {
    menuId: sessionStorage.getItem('menuId'), // 菜单ID
    oldpwd: '',
    newpwd: '',
    newpwdr: ''
  }
}
// 提交
const submitForm = async () => {
  const form = unref(ruleFormRef)
  if (!form) return
  await form.validate()
  if (ruleForm.value.newpwd === ruleForm.value.newpwdr) {
    ruleForm.value.menuId = sessionStorage.getItem('menuId')
    const data = {
      menuId: sessionStorage.getItem('menuId'),
      id: '',
      ymm: ruleForm.value.oldpwd,
      xmm: ruleForm.value.newpwdr
    }
    mimaEdit(data).then((res) => {
      if (res.code === 200) {
        emits('ReturnData')
        handleClose()
        successPrompt(res.message)
      } else {
        warningPrompt(res.message)
      }
    })
  } else {
    warningPrompt('两次密码不一致')
  }
}
</script>
